import { createSlice } from '@reduxjs/toolkit'

export const autoScanSlice = createSlice({
  name: 'autoScan',
  initialState: {
    isAutoScan: false,
  },
  reducers: {
    setIsAutoScan: (state, action) => {
      state.isAutoScan = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { setIsAutoScan } = autoScanSlice.actions
export const isAutoScan = (state) => state.autoScan.isAutoScan
export default autoScanSlice.reducer